import React, { Component } from 'react';
interface ErrorBoundaryProps {
  children: React.ReactNode;
}
interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen bg-white flex items-center justify-center p-4" data-id="element-523">
          <div className="text-center" data-id="element-524">
            <h1 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-525">
              Något gick fel
            </h1>
            <p className="text-gray-600 mb-4" data-id="element-526">
              Vi ber om ursäkt, men något oväntat inträffade. Försök att
              uppdatera sidan.
            </p>
            <button onClick={() => window.location.reload()} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-527">
              Uppdatera sidan
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}